import {Component} from '@angular/core'
import {IonFooter, IonItem, IonLabel} from '@ionic/angular/standalone'

@Component({
  selector: 'app-footer-menu',
  imports: [IonFooter, IonItem, IonLabel],
  templateUrl: './footer-menu.html',
  styleUrl: './footer-menu.scss',
})
export class FooterMenuComponent {}
